<span *ngIf="loading; else valueTpl"
      class="ft-yoy-delta"
      [class.-inline]="inline">
    <span class="ft-yoy-delta_spinner"></span>
</span>
<ng-template #valueTpl>
    <span *ngIf="label"
          class="ft-yoy-delta"
          [class.-inline]="inline"
          [class.-up]="kind === 'up'"
          [class.-down]="kind === 'down'"
          [class.-flat]="kind === 'flat'"
          [class.-na]="kind === 'na'">
        <!-- First char of the label is always the Unicode arrow / divider glyph (↑ ↓ – ▵);
             split so flex can vertically centre it next to the digits. -->
        <span class="ft-yoy-delta_arrow">{{ label.charAt(0) }}</span>
        <span class="ft-yoy-delta_value">{{ label.substring(1) }}</span>
    </span>
</ng-template>
